
import axios from "axios";
import { baseURL } from "./constants";

const axiosMainUrl = axios.create({
     baseURL: baseURL
})

axiosMainUrl.interceptors.request.use((config) => {
     const token: string | undefined = localStorage.getItem("tkn") as string;
     if (token) {
          config.headers.Authorization = `Bearer ${token}`;
     }
     if (config.url === "/client/attachments" || config.url === "/login") {
          config.headers["Content-Type"] = 'multipart/form-data'
     }
     else {
          config.headers["Content-Type"] = 'application/json';
     }
     return config;
});

axiosMainUrl.interceptors.response.use (
(response) => response,
async (error) => {
     const originalRequest = error.config;
     if (error.response !== undefined && originalRequest.url !== "/login" && error.response.status === 500 && error.response.data.trace?.includes("AuthenticationFailedException")) {
         originalRequest._retry = true;
         try {
              const refreshToken = localStorage.getItem('reftkn');
              const response = await axiosMainUrl.post('/login/token/update',  JSON.stringify({ refreshToken: refreshToken }) );
              const token = response.data;
              localStorage.setItem('tkn', token);
              originalRequest.headers.Authorization = `Bearer ${token}`;
              return axios(originalRequest);
         }
         catch (error: any) {
              localStorage.clear();
              window.location.reload();
              return Promise.reject(error);
         }
     }
     return Promise.reject(error);
})

export const handleLogin = async (formData: any) => {
     try {
          return await axiosMainUrl.post("/login", formData);
     }
     catch (error) {
          console.log(error);
     }
}

export const savingClient = async (data: any): Promise<any> => {
     try {
          return await axiosMainUrl.post(`/client/create`, data);
     }
     catch (error) {
          console.log(error);
     }
}

export const saveClientImages = async (formData: any): Promise<any> => {
     try {
          return  await axiosMainUrl.post("/client/attachments", formData);
     }
     catch (error) {
          console.log(error);
     }
}

export const getUsers = async (): Promise<any> => {
     try {
          return await axiosMainUrl.get(`/user/form`);
     }
     catch (error) {
          console.log(error);
     }
}

export const allClients = async (): Promise<any> => {
     try {
          return await axiosMainUrl.get("/client/all");
     }
     catch (error) {
          console.log(error);
     }
}

export const deleteClient = async (id: string): Promise<any> => {
     try {
          return await axiosMainUrl.delete(`/client/delete/${id}`);
     }
     catch (error) {
          console.log(error);
     }
}

export const cancelation = async (data: { clientId: number, cancellationReason: string | undefined }): Promise<any> => {
     try {
          return await axiosMainUrl.post(`/client/status`, data);
     }
     catch (error) {
          console.log(error);
     }
}

export const findClientById = async (id: number): Promise<any> => {
     try {
          return await axiosMainUrl.get(`/client/${id}`);
     }
     catch (error) {
          console.log(error);
     }
}

export const deleteAttachment = async (id : number): Promise<any> => {
     try {
          return await axiosMainUrl.get(`/client/attachment/${id}`);
     }
     catch (error) {
          console.log(error);
     }
}

export const getAllUsers = async () => {
     try {
          return await axiosMainUrl.get("/user/all");
     }
     catch (err) {
          console.log(err);
     }
}

export const createUser = async (data: any): Promise<any> => {
     try {
          return await axiosMainUrl.post("/user/create", data);
     }
     catch (error) {
          console.log(error);
     }
}

export const deleteUser = async (id: number): Promise<any> => {
     try {
          return await axiosMainUrl.delete(`/user/delete/${id}`);
     }
     catch (error) {
          console.log(error);
     }
}

export const findUserById = async (id: number): Promise<any> => {
     try {
          return await axiosMainUrl.get(`/user/${id}`);
     }
     catch (error) {
          console.log(error);
     }
}

export const gettingActivity = async () => {
     try {
          return await axiosMainUrl.get(`/activity/all`);
     }
     catch (err) {
          console.log(err);
     }
}

export const gettingUsers = async () => {
     try {
          return await axiosMainUrl.get(`/user/all`);
     }
     catch (err) {
          console.log(err);
     }
}

export const pinCodeValidation = async (pinCode: string): Promise<any> => {
     try {
          return await axiosMainUrl.get(`/user/pin-code/${pinCode}`);
     }
     catch (error) {
          console.log(error);
     }
}

export const addComment = async (data: any): Promise<any> => {
     try {
          return await axiosMainUrl.post("/billing/comment/save", data);
     }
     catch (error) {
          console.log(error);
     }
}

export const getAllComments = async (clientId: number): Promise<any> => {
     try {
          return await axiosMainUrl.get(`/billing/comment/${clientId}/all`);
     }
     catch (error) {
          console.log(error);
     }
}

export const deleteComment = async (id: number): Promise<any> => {
     try {
          return await axiosMainUrl.delete(`/billing/comment/delete/${id}`);
     }
     catch (err) {
          console.log(err)
     }
}

export const getStatisticsData = async () => {
     try {
          return await axiosMainUrl.get(`/client/analytics`);
     }
     catch (err) {
          console.log(err);
     }
}
